import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { TwDocumentacionCamViewModel } from '../campania/documentacioncam/documentacioncam.types';

export class CampaniaEspecificaItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TCampaniaEspecificaViewModel[];
}

export class FilterSearchingTCampaniaEspecificaViewModel extends FilterSearchingBaseViewModel {
    public Id: number | null;
    public IdPais: number | null;
    public Descripcion = '';
    public IdModeloCf: number | null;
    public IdIdioma: number | null;
}

export class TCampaniaEspecificaViewModel {
    public Id?: number | null;
    public IdPais: number | null;
    public Descripcion: string;
    public Pais: string;
    public IdModeloCf: number;
    public ModeloCf: string;
    public FechaCreacion?: Date;
    public AdjuntarDocumentacion: boolean;
    public Documentacion: TwDocumentacionCamViewModel[];
    public IdIdioma?: number;
    public Idioma: string;
}
